module.exports = __webpack_public_path__ + "img/logo.818462e3.png";